import axiosService from './axios-service';
import {Address, CategoryUrl, Domain, FwVersion} from '../dtos/version.dto';
import {PresetDto} from '../dtos/preset.dto';
import {buildAddressPayload} from '@src/utils/versionUtils';

class BronzeService {

    public getLatestVersion = async (customerId: number, serviceId: number): Promise<FwVersion> => {
        const result = await axiosService.get(`/api/firewall/customer/${customerId}/service/${serviceId}/version/latest`);
        return result?.data;
    };

    public applyBronzePolicy = async (
        customerId: number,
        serviceId: number,
        versionId: string,
        addresses: Address[],
        domains: Domain[],
        categories: CategoryUrl[]
    ): Promise<FwVersion> => {
        const result = await axiosService.post(`/api/firewall/customer/${customerId}/service/${serviceId}/bronze-version-action`, {
            externalId: versionId,
            addresses: addresses.map(add => buildAddressPayload(add)),
            domains: domains.map(d => ({...d, name: d.domainUrl})),
            categories
         });
        return result?.data;
    };

    public deactivateDnsProtection = async (customerId: number, serviceId: number, versionId: string, isDeactivate: boolean): Promise<FwVersion> => {
        const result = await axiosService.put(`/api/firewall/customer/${customerId}/service/${serviceId}/toggleDns`, {
            externalId: versionId,
            dnsEnabled: !isDeactivate
         });
        return result?.data;
    };

    public getPresets = async (): Promise<PresetDto[]> => {
        const result = await axiosService.get(`/api/firewall/systemConfig/bronze-category-groups`);
        return result?.data;
    };
}

const bronzeService = new BronzeService();
export default bronzeService;